import { ThunkType } from "../../../../../core/store/reducers";
import { getMemberContractsReport } from "../api/getMemberContractsReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../memberContractsDataSlice";

export const downloadMemberContractsReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getMemberContractsReport(user));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "MemberCintracts.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
